export const getTariff = (tariff) => {
  switch (tariff) {
    case 'free':
      return 'Бесплатный';
    case 'onetime':
      return 'Разовый';
    case 'hr':
      return 'HR 1';
    case 'hr_result':
      return 'HR 2';
    case 'hr_guarantee':
      return 'HR 3';
    default:
      break;
  }
};
